<template>
  <keep-alive>
    <div class="container">
      <header class="top-navbar">
        <div class="logo">
          <img
            class="logo-img"
            src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/greyd-logo.png"
            @click.prevent="scrollPageTo('intro', false)"
          />
          <a class="navbar__toogleBtn" @click="showMenu()">
            <i
              class="fa-solid fa-bars"
              style="color: white; font-size: 1.5rem; margin-right: 10px"
            ></i>
          </a>
        </div>

        <div class="menus" :class="{ active: isActive }">
          <span class="menu" @click.prevent="scrollPageTo('intro')">Intro</span>
          <span class="menu" @click.prevent="scrollPageTo('register')"
            >Register</span
          >
          <span class="menu" @click.prevent="scrollPageTo('about')">About</span>
          <span class="menu" @click.prevent="scrollPageTo('service')"
            >Service</span
          >
          <span class="menu" @click.prevent="scrollPageTo('brands')"
            >Brands</span
          >
          <span class="menu" @click.prevent="scrollPageTo('qna')">Q&A</span>
        </div>

        <div class="languages" :class="{ active: isActive }">
          <span class="language" @click="changeLanguage('ko')">KOR</span>
          <span class="language" @click="changeLanguage('en')">ENG</span>
        </div>
      </header>

      <div class="carousel-container" id="intro">
        <swiper ref="swiper" :options="swiperOptions" class="swiper">
          <swiper-slide
            class="swiper-slide"
            :style="{
              backgroundImage: `url('https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/swiper-1.png')`,
            }"
          >
            <div class="swiper-background"></div>
            <div class="intro-container">
              <span class="intro-header"
                >Intro <span style="color: white">1/5</span></span
              >
              <section class="intro-title">
                {{ $t("newMain.intro1.title1") }}<br />
                {{ $t("newMain.intro1.title2") }}
              </section>
              <p class="intro-content">
                {{ $t("newMain.intro1.content") }}
              </p>
              <div class="appstoreButtonsContainer">
                <a
                  href="https://play.google.com/store/apps/details?id=com.arbaim.greyd"
                  target="_blank"
                  class="appstoreButton"
                >
                  <img
                    src="@/assets/icons/ic_playstore.png"
                    class="appstoreIcon"
                  />
                  Google Play
                </a>
                <a
                  href="https://apps.apple.com/us/app/com-arbaim-greyd/id1526096078"
                  target="_blank"
                  class="appstoreButton"
                >
                  <img
                    src="@/assets/icons/ic_appstore.png"
                    class="appstoreIcon"
                  />
                  App Store
                </a>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide
            class="swiper-slide"
            :style="{
              backgroundImage: `url('https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/swiper-2.png')`,
            }"
          >
            <div class="swiper-background"></div>
            <div class="intro-container">
              <span class="intro-header"
                >Intro <span style="color: white">2/5</span></span
              >
              <section class="intro-title">
                {{ $t("newMain.intro2.title1") }}<br />
                {{ $t("newMain.intro2.title2") }}
              </section>
              <p class="intro-content">
                {{ $t("newMain.intro2.content") }}
              </p>
            </div>
          </swiper-slide>
          <swiper-slide
            class="swiper-slide"
            :style="{
              backgroundImage: `url('https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/swiper-3.jpg')`,
            }"
          >
            <div class="swiper-background"></div>
            <div class="intro-container-3">
              <span class="intro-header"
                >Intro <span style="color: white">3/5</span></span
              >
              <section class="intro-title">
                {{ $t("newMain.intro3.title1") }}<br />
                {{ $t("newMain.intro3.title2") }}
              </section>
              <p class="intro-content">
                {{ $t("newMain.intro3.content") }}
              </p>
            </div>
          </swiper-slide>
          <swiper-slide
            class="swiper-slide"
            :style="{
              backgroundImage: `url('https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/swiper-4.png')`,
            }"
          >
            <div class="swiper-background"></div>
            <div class="intro-container-4">
              <span class="intro-header"
                >Intro <span style="color: white">4/5</span></span
              >
              <div class="swiper-background"></div>
              <section class="intro-title">
                {{ $t("newMain.intro4.title1") }}<br />
                {{ $t("newMain.intro4.title2") }}
              </section>
              <p class="intro-content">
                {{ $t("newMain.intro4.content") }}
              </p>
            </div>
          </swiper-slide>
          <swiper-slide
            class="swiper-slide"
            :style="{
              backgroundImage: `url('https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/swiper-5.jpg')`,
            }"
          >
            <div class="swiper-background"></div>
            <div class="intro-container">
              <span class="intro-header"
                >Intro <span style="color: white">5/5</span></span
              >
              <section class="intro-title">
                {{ $t("newMain.intro5.title1") }}<br />
                {{ $t("newMain.intro5.title2") }}
              </section>
              <p class="intro-content">
                {{ $t("newMain.intro5.content") }}
              </p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>

      <register id="register" />
      <about id="about" />
      <service id="service" />
      <brands id="brands" />
      <qna id="qna" :language="language" />

      <!-- v-if="currentPage == 'intro' || currentPage == 'about'"
      v-else-if="currentPage == 'register'"
      v-else-if="currentPage == 'service'"
      v-else-if="currentPage == 'brands'" -->

      <div></div>
    </div>
  </keep-alive>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import About from '@/components/renewal/components/About'
import Register from '@/components/renewal/components/Register'
import Service from '@/components/renewal/components/Service'
import Brands from '@/components/renewal/components/Brands'
import Qna from './components/Qna.vue'

export default {
  metaInfo: {
    title: this.vuePageTitle,
    // titleTemplate: '%s | www.ex.com', // title 뒤에 붙일 공통된 이름 (주로 사이트이름)
    htmlAttrs: {
      lang: navigator.language // i18n 사용하지 않는 경우 직접 입력
    },
    meta: [
      { charset: 'utf-8' },
      // SEO setting
      {
        name: 'description',
        content: String(this.vuePageDescription).slice(0, 320),
        vmid: 'description'
      },
      // { name: 'keywords', content: this.board.keywords },
      // { name: 'author', content: this.board.author },
      // SNS 용
      {
        property: 'og:title',
        content: this.vuePageTitle,
        template: (chunk) => `${chunk} | greyd.app`,
        vmid: 'og:title'
      },
      // mobile
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  },
  name: 'NewMain',
  created () {
    let locale = navigator.language || navigator.userLanguage
    locale = locale.substring(0, 2)
    if (locale !== 'ko') locale = 'en' // 한국어가 아닌 경우 무조건 영어로 설정
    this.$i18n.locale = locale

    this.vuePageTitle = this.$i18n.t('newMain.title')
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      isActive: false,
      pages: ['about', 'service', 'register', 'brands', 'qna'],
      currentPage: 'about',
      language: 'ko',
      vuePageTitle: '그레이드',
      vuePageDescription: '내 경험을 공유하면 돈을 벌 수 있는 세상'
    }
  },
  watch: {
    vuePageTitle (to) {
      document.title = to
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    About,
    Register,
    Service,
    Brands,
    Qna
  },
  mounted: {},
  methods: {
    changeLanguage (language) {
      this.$i18n.locale = language
      this.language = language
      this.isActive = !this.isActive
      this.vuePageTitle = this.$i18n.t('newMain.title')
      this.vuePageDescription = this.$i18n.t('newMain.description')
    },
    showMenu () {
      this.isActive = !this.isActive
    },
    scrollPageTo (navEl, showMenu = true) {
      if (showMenu) {
        this.showMenu()
      }
      this.changeToRegisterPage(navEl)

      setTimeout(() => {
        // console.log(`#${navEl}`)
        let element = document.querySelector(`#${navEl}`)
        // console.log(element)
        element.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    },
    changeToRegisterPage (pageName) {
      this.currentPage = pageName
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/reset.css"></style>
<style scoped src="@/assets/styles/intro.css"></style>
<style scoped src="@/assets/styles/intro-mobile.css"></style>
<style scoped src="@/assets/styles/custom-swiper.css"></style>
<style>
html {
  overflow-x: hidden;
  background: #3a3a3a;
}
</style>



// WEBPACK FOOTER //
// src/components/renewal/NewMain.vue